import { useEffect, useState } from "react";
import { handleOpenAthensCallback } from "../../authConfig";
import { useNavigate } from "react-router-dom";

const CallbackPage = () => {
  const [error, setError] = useState(null);
  const navigate = useNavigate;
  useEffect(() => {
    const handleCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code");

      if (!code) {
        setError("No authentication code received");
        return;
      }

      try {
        const authResult = await handleOpenAthensCallback(code);

        localStorage.setItem("auth", JSON.stringify(authResult));

        navigate("/profile");
      } catch (err) {
        setError(err.message);
      }
    };

    handleCallback();
  }, [navigate]);

  if (error) {
    return <div className="text-red-500">Error: {error}</div>;
  }

  return <div>Authenticating...</div>;
};

export { CallbackPage };
